module.exports = __webpack_public_path__ + "@/assets/img/write.fd528991.svg";